export default __webpack_public_path__ + "static/media/oversight2.a5fe85b0.png";